import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import _LinkIcon from '@/assets/images/icons/link_outer_icon.svg?react';
import _ChipClock from '@/assets/images/icons/chip_clock.svg?react';

export const Wrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
});

export const PopperContent = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '200px',
    maxWidth: 'calc(100vw - 32px)',
    minHeight: '40px',
    backgroundColor: theme.palette.backgrounds.bg2,
    borderRadius: '8px',
    padding: '4px 8px',
    overflow: 'hidden',
}));

export const CohortList = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    minWidth: '350px',
    maxWidth: '100%',
    maxHeight: 'min(400px, 60vh)',
    overflowY: 'auto',
    overflowX: 'hidden',

    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.palette.backgrounds.bg4,
        borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: theme.palette.hyperLiquidColor,
    },
}));

export const TickerList = styled(CohortList)({});
export const BuildersList = styled(CohortList)({});

export const CohortListRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '8px 4px',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: `${theme.palette.hyperLiquidColor}1A`,
    },
}));

export const TickerListRow = styled(CohortListRow)({});
export const BuilderListRow = styled(CohortListRow)({});

export const WalletRow = styled(CohortListRow)(({ theme }) => ({
    minWidth: '450px',
    maxWidth: '100%',
    '&:hover': {
        backgroundColor: `${theme.palette.hyperLiquidColor}1A`,
    },
}));

export const LinkIcon = styled(_LinkIcon)(({ theme }) => ({
    path: {
        stroke: theme.palette.hyperLiquidColor,
    },
}));

export const ChipsList = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '6px',
});

export const ChipClock = styled(_ChipClock)({});

export const SearchMobileWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    width: '100%',
    padding: '8px 4px',
    gap: '12px',
});

export const MobileChipsWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '6px',
});

export const ImageIcon = styled('img')({
    width: '16px',
    height: '16px',
});

export const BuilderRow = styled(Box)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '6px',
});
